import { atom } from 'recoil';

export const clientTypeState = atom({
  key: 'clientTypeState',
  default: 6,
});

const clientCategoryState = atom({
  key: 'clientCategoryState',
  default: 6,
});

export default clientCategoryState;
